const sortPrices = [
    { key: 'desc', label: 'Price(High to Low)' },
    { key: 'asc', label: 'Price(Low to High)' }
];

export default sortPrices;